

export const Footer = () => {
  return (
    <div className="h-96 w-full bg-black-main mt-16 border-t-4 border-black border-solid">

    </div>
  );
};

export default Footer;